module.exports = __webpack_public_path__ + "img/technology-2.e44cd6dc.webp";